import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// const sampleData = [
//   {
//     day: "1",
//     orders: 10,
//     amt: 2400,
//   },
//   {
//     day: "2",
//     orders: 20,
//     amt: 2210,
//   },
//   {
//     day: "3",
//     orders: 15,
//     amt: 2290,
//   },
//   {
//     day: "4",
//     orders: 16,
//     amt: 2000,
//   },
//   {
//     day: "5",
//     orders: 17,
//     amt: 2181,
//   },
//   {
//     day: "6",
//     orders: 18,
//     amt: 2500,
//   },
//   {
//     day: "7",
//     orders: 18,
//     amt: 2100,
//   },
//   {
//     day: "8",
//     orders: 25,
//     amt: 2400,
//   },
//   {
//     day: "9",
//     orders: 27,
//     amt: 2210,
//   },
//   {
//     day: "10",
//     orders: 28,
//     amt: 2290,
//   },
//   {
//     day: "11",
//     orders: 27,
//     amt: 2000,
//   },
//   {
//     day: "12",
//     orders: 18,
//     amt: 2181,
//   },
//   {
//     day: "13",
//     orders: 23,
//     amt: 2500,
//   },
//   {
//     day: "14",
//     orders: 34,
//     amt: 2100,
//   },
//   {
//     day: "15",
//     orders: 40,
//     amt: 2400,
//   },
//   {
//     day: "16",
//     orders: 30,
//     amt: 2210,
//   },
//   {
//     day: "17",
//     orders: 20,
//     amt: 2290,
//   },
//   {
//     day: "18",
//     orders: 20,
//     amt: 2000,
//   },
//   {
//     day: "19",
//     orders: 19,
//     amt: 2181,
//   },
//   {
//     day: "20",
//     orders: 29,
//     amt: 2500,
//   },
//   {
//     day: "21",
//     orders: 39,
//     amt: 2100,
//   },
//   {
//     day: "22",
//     orders: 60,
//     amt: 2400,
//   },
//   {
//     day: "23",
//     orders: 12,
//     amt: 2210,
//   },
//   {
//     day: "24",
//     orders: 28,
//     amt: 2290,
//   },
//   {
//     day: "25",
//     orders: 23,
//     amt: 2000,
//   },
//   {
//     day: "26",
//     orders: 19,
//     amt: 2181,
//   },
//   {
//     day: "27",
//     orders: 22,
//     amt: 2500,
//   },
//   {
//     day: "28",
//     orders: 32,
//     amt: 2100,
//   },
//   {
//     day: "29",
//     orders: 36,
//     amt: 2500,
//   },
//   {
//     day: "30",
//     orders: 34,
//     amt: 2100,
//   },
// ];

const Graph = ({ graphData }) => {
  return (
    <ResponsiveContainer width={"100%"} height="100%">
      <AreaChart data={graphData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id="primaryGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#3B82F6" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
        <XAxis 
            dataKey="day" 
            tick={{ fontSize: 11, fill: "#9CA3AF" }} 
            axisLine={false} 
            tickLine={false} 
            dy={10} 
            padding={{ left: 10, right: 10 }}
        />
        <YAxis 
            tick={{ fontSize: 11, fill: "#9CA3AF" }} 
            axisLine={false} 
            tickLine={false} 
            dx={-10} 
        />
        <Tooltip
            cursor={{ fill: 'rgba(0,0,0,0.02)' }}
            contentStyle={{ 
                borderRadius: "12px", 
                border: "1px solid #E5E7EB", 
                boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)", 
                padding: "10px 14px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#374151"
            }}
            itemStyle={{ color: "#3B82F6" }}
        />
        <Area 
            type="monotone" 
            dataKey="orders" 
            name="Orders"
            stroke="#3B82F6" 
            strokeWidth={3}
            fillOpacity={1} 
            fill="url(#primaryGradient)" 
            activeDot={{ r: 6, strokeWidth: 0, fill: "#2563EB" }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default Graph;
